<template>
  <div>
    <header class="form-title">
      <Row>
        <Col span="22">
          <Form inline :label-width="80">
            <FormItem prop="user" label="供应商">
              <el-Select size="small" filterable v-model="formSelect.user" class="formSelect-input">
                <el-Option
                  :value="k.id"
                  v-for="(k,v) in customerList"
                  :key="v"
                  :label="k.name+(k.phone!=null?k.phone:'')"
                >{{k.name+(k.phone!=null?k.phone:"")}}</el-Option>
              </el-Select>
            </FormItem>
            <FormItem prop="password" label="门店">
              <Input v-model="formSelect.store" class="formSelect-input" disabled />
            </FormItem>
            <FormItem prop="password" label="采购员">
              <Input v-model="adminuser" class="formSelect-input" disabled />
            </FormItem>
          </Form>
        </Col>
        <Col span="2" align="right">
          <Button
            style="position: relative;top: -10px;"
            type="primary"
            @click="commodityModal=true"
          >
            <Icon type="md-add" />
          </Button>
        </Col>
      </Row>
    </header>
    <div>
      <Alert v-if="afterSelection.length==0" align="center">请添加商品</Alert>
      <Collapse v-model="opensTable" v-if="afterSelection.length!=0">
        <Panel :name="index+''" v-for="(item,index) in afterSelection" :key="index">
          <span>{{ item.goodsname }} ({{item.goodscode}})</span>
          <table slot="content" class="ive-table">
            <thead>
              <th>商品图</th>
              <th>规格</th>
              <th>颜色</th>
              <th>
                采购价
                <span class="finger" @click="editallprice(item)">
                  <Icon type="md-create" />
                </span>
              </th>
              <th>数量</th>
              <th>小计</th>
              <th>操作</th>
            </thead>
            <tbody>
              <tr align="center" v-for="(k,v) in item.goodsItem" :key="v">
                <td :rowspan="item.goodsItem.length" v-if="v==0" width="240">
                  <Fy-Img
                    :ImgSrc="item.goodsimg | filtImg(item.goodsimg)"
                    :Width="100"
                    :Height="100"
                  ></Fy-Img>
                </td>
                <td>{{k.size}}</td>
                <td>{{k.color}}</td>
                <td class="finger">
                  <InputNumber
                    style="width: 100px"
                    v-model="k.cprice"
                    size="small"
                    :min="0"
                    :max="999999"
                    :precision="2"
                    @on-change="editprice(item,v,k.cprice,1)"
                  ></InputNumber>
                </td>
                <td class="finger">
                  <InputNumber
                    v-if="isShowcprice"
                    v-model="k.nums"
                    size="small"
                    :max="9999"
                    :min="1"
                    @on-change="editprice(item,v,k.nums,2)"
                  ></InputNumber>
                  <InputNumber
                    v-else
                    v-model="k.nums"
                    size="small"
                    :max="9999"
                    :min="1"
                    @on-change="editprice(item,v,k.nums,2)"
                  ></InputNumber>
                </td>

                <td>{{(k.cprice*k.nums).toFixed(2)}}</td>
                <td :rowspan="item.goodsItem.length" v-if="v==0" width="200">
                  <ButtonGroup shape="circle">
                    <Button type="primary" icon="md-create" title="编辑" @click="editSendData(item)"></Button>
                    <Button
                      type="warning"
                      icon="md-trash"
                      title="删除"
                      @click="delSendData(item,index)"
                    ></Button>
                  </ButtonGroup>
                </td>
              </tr>
            </tbody>
          </table>
        </Panel>
      </Collapse>
      <Row style="margin-top: 30px">
        <Col span="4">
          <span class="msg">
            商品金额：
            <strong>{{formSelect.showMoneys.toFixed(2)}}</strong>
          </span>
        </Col>
        <Col span="4">
          <span class="msg">
            商品数量：
            <strong>{{formSelect.total}}</strong>
          </span>
        </Col>
        <Col span="4">
          <span class="msg">
            欠供应商款：
            <strong>{{formSelect.customerArrears.toFixed(2)}}</strong>
          </span>
        </Col>
        <Col span="4">
          <span class="msg">
            本单欠款：
            <strong>{{formSelect.nomoneys.toFixed(2)}}</strong>
          </span>
        </Col>
        <Col span="20">
          <Form inline :label-width="100">
            <FormItem label="结算账户：">
              <el-Select filterable size="small" v-model="formSelect.bank" class="formSelect-input">
                <el-Option
                  v-if="k.type!=6"
                  :value="k.id"
                  v-for="(k,v) in bankList"
                  :key="v"
                  :label="k.bankname"
                >{{k.bankname}}</el-Option>
              </el-Select>
            </FormItem>
            <FormItem label="实收金额">
              <el-Input
                size="small"
                min="0"
                maxlength="10"
                @input="checkNumber"
                v-model="formSelect.realMoney"
                class="formSelect-input"
                ref="realMoneyKey"
                name="realMoneyName"
              ></el-Input>
            </FormItem>
          </Form>
        </Col>
        <Col span="4" align="center">
          <span>合计：{{Lastmoney}}</span>
          <Button
            type="primary"
            :loading="loadingOpeningOrder"
            @click="openingOrder()"
            style="margin-left: 15px"
          >
            <span v-if="!loadingOpeningOrder">采购</span>
            <span v-else>提交中</span>
          </Button>
        </Col>
        <Col span="6">
          <Form inline :label-width="60">
            <FormItem label="备注">
              <Input
                v-model="formSelect.remark"
                type="textarea"
                style="width: 500px"
                :maxlength="50"
                placeholder="备注(最多50个字符)"
              />
            </FormItem>
          </Form>
        </Col>
      </Row>
    </div>
    <!--选择商品-->
    <Modal width="90%" v-model="commodityModal" title="选择添加的商品">
      <Form inline>
        <FormItem prop="password">
          <Input type="text" v-model="searchNeirong" placeholder="请输入商品名、货号"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="getGoodsList()">搜索</Button>
        </FormItem>
        <FormItem prop="password">
          <Input type="text" v-model="searchnumber" placeholder="请输入条形码"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="setGoodsList()">搜索</Button>
        </FormItem>
      </Form>
      <div class="demo-split">
        <Split v-model="split">
          <div slot="left" class="demo-split-pane">
            <table slot="content" class="ive-table">
              <thead>
                <th>选择</th>
                <th width="100">商品图</th>
                <th width="180">名称</th>
                <th>货号</th>
                <th>库存</th>
                <th>零售价</th>
                <th v-if="ispfprice">批发价</th>
                <th v-if="cpriceFlag">采购价</th>
                <th>已选</th>
              </thead>
              <tbody>
                <tr
                  align="center"
                  v-for="(item, index) in goodsListL"
                  :key="index"
                  @click="setDataListFn(goodsListL,index)"
                  style="cursor: pointer"
                >
                  <td width="80">
                    <RadioGroup v-model="resultItem.single">
                      <Radio :label="item.id">{{index+1}}</Radio>
                    </RadioGroup>
                  </td>
                  <td>
                    <div class="imgbox">
                      <Fy-Img
                        class="img"
                        :ImgSrc="item.goodsimg | filtImg(item.goodsimg)"
                        :Width="50"
                        :Height="50"
                      ></Fy-Img>
                      <span v-if="item.tagCode!=null">总</span>
                    </div>
                  </td>
                  <td>{{item.name}}</td>
                  <td>{{item.goodscode}}</td>
                  <td>{{item.num}}</td>
                  <td>{{item.lprice}}</td>
                  <td v-if="ispfprice">{{item.pprice}}</td>
                  <td v-if="cpriceFlag">{{item.cprice}}</td>
                  <td v-if="item.nums>0" style="color: #ff9900">{{item.nums}}</td>
                  <td v-else>{{item.nums}}</td>
                </tr>
              </tbody>
            </table>
            <div class="pageTotal">
              <Page
                :total="page.total"
                show-total
                :current.sync="page.current"
                :page-size="page.rows"
                @on-change="onChange"
              />
              <span class="zongshu">共: {{allnumber}} 件</span>
            </div>
          </div>
          <div slot="right" class="demo-split-pane">
            <div class="commodityMsg">
              <span class="img" v-if="resultItem.goodsimg==''">暂无商品图片</span>
              <Fy-Img class="img" :ImgSrc="resultItem.goodsimg" :Width="80" :Height="80"></Fy-Img>
              <h2>{{resultItem.name}}</h2>
              <!-- <h3>
                零售价:
                <span class="money">￥{{resultItem.lprice}}</span>
              </h3>
              <h3>
                批发价:
                <span class="money">￥{{resultItem.pprice}}</span>
              </h3> -->
              <h3 v-if="cpriceFlag">
                采购价:
                <span class="money">￥{{resultItem.price}}</span>
              </h3>
              <h3>
                库存:
                <span class="num">{{resultItem.num}}</span>
              </h3>
            </div>
            <div style="max-height: 400px;overflow: auto" class="overflowRightNav">
              <div class="commodityClolr">
                <h3>选择颜色</h3>
                <span
                  class="tag"
                  v-for="(m,n) in resultItem.colors"
                  :key="n"
                  :class="{isSelectClass:selectColorGroup.isCheckable==n}"
                  @click="setColorsFn(goodsListL,selectColorGroup.index,n)"
                >{{m.color}}</span>
              </div>
              <div class="commoditymiss">
                <table>
                  <tr>
                    <th>库存</th>
                    <th>规格</th>
                    <th>颜色</th>
                    <th>
                      <InputNumber
                        v-if="isShowcprice"
                        :min="0"
                        size="small"
                        :readonly="numsreadonly"
                        v-model="selectData.all"
                        @on-change="selectDataAll"
                        @on-focus="allchangeNums(numsreadonly)"
                      ></InputNumber>
                      <InputNumber
                        v-else
                        :min="0"
                        size="small"
                        v-model="selectData.all"
                        @on-change="selectDataAll"
                      ></InputNumber>
                    </th>
                  </tr>
                  <tr v-for="(item, index) in resultItem.goodsItem">
                    <td>{{item.num}}</td>
                    <td>{{item.size}}</td>
                    <td>{{item.color}}</td>
                    <td>
                      <InputNumber
                        v-if="isShowcprice"
                        :min="0"
                        size="small"
                        :readonly="item.num<0"
                        v-model="item.nums"
                        @on-change="changeNums(item)"
                        @on-focus="changeNums(item)"
                      ></InputNumber>
                      <InputNumber
                        v-else
                        :min="0"
                        size="small"
                        v-model="item.nums"
                        @on-change="changeNums(item)"
                      ></InputNumber>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <div class="Total">
              <h3>
                <Row>
                  <Col span="12">共: {{summary.totalPieces}} 件</Col>
                  <Col span="12">合计:￥ {{summary.totalMoney.toFixed(2)}}</Col>
                </Row>
              </h3>
            </div>
          </div>
        </Split>
      </div>
      <div slot="footer">
        <Button type="text" @click="commodityModal=false">取消</Button>
        <Button type="primary" @click="addsSelectItem('true')">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import FyImg from "../../components/Common/FyImg";
export default {
  components: { FyImg },

  data() {
    return {
      // 扫描条形码
      searchnumber: null,
      // 所有选择总数
      changenumber: 0,
      changeid: 0,
      allnumber: 0,
      allobj: [],
      cid: "",
      sid: "",
      adminuser: JSON.parse(localStorage.getItem("adminUser")).name, //当前登录的采购员
      opensTable: "0", //默认展开第一个
      customerList: [], //供应商
      bankList: [], //结算账户
      loadingOpeningOrder: false,

      formSelect: {
        user: "",
        store: "",
        adminuserid: JSON.parse(localStorage.getItem("adminUser")).id,
        salesperson: JSON.parse(localStorage.getItem("adminUser")).id,
        salespersonid: null,
        bank: "",
        bankName: "",
        realMoney: 0,
        nomoneys: 0, //本单欠款
        customerArrears: 0,
        showMoneys: 0, //商品金额，
        total: 0, //总件数
        remark: ""
      },
      afterSelection: [], //发送的数据
      currentPageData: [], //当前页所选的数据
      searchNeirong: "",
      resultItem: {
        //默认显示详情
        single: null,
        img: "",
        name: "",
        price: "",
        num: "",
        colors: [],
        sizes: [],
        goodsItem: []
      },
      resultNum: 0,
      selectData: {
        all: 0
      },
      //总件
      summary: {
        totalPieces: 0,
        totalMoney: 0
      },
      //记录数选择数值
      selectColorGroup: {
        isCheckable: 0,
        index: 0
      },
      goodsListL: [],
      commodityModal: false, //选商品
      split: 0.7,
      page: {
        current: 1, //当前页
        total: 1,
        page: 1,
        rows: 8
      },
      isShowcprice: false,
      numsreadonly: false, //是否限制修改数量
      Lastmoney: 0, //最后实际付款
      ispfprice: true, //判断是否显示批发价
      ischooseing: true,
      getEdtiVal: "",
      itemid: "", //修改百分比记录点击的是哪条数据
      itemi: "", //修改百分比记录点击的是哪条数据的子级
      statenum: 0, //采购平均价
      historyPrice: false, //商品列表页面返回和换供应商时查历史价格开关
      againSale:true,//再次开单标志，只用一次
      cpriceFlag:true,//成本权限
    };
  },
  created: function() {
    //获取用户信息
    this.cid = JSON.parse(localStorage.getItem("shop")).cid;
    this.sid = JSON.parse(localStorage.getItem("shop")).id;
    this.statenum = JSON.parse(localStorage.getItem("shop")).iscprice;
    JSON.parse(localStorage.getItem("shop")).iscprice == 0
      ? (this.isShowcprice = false)
      : (this.isShowcprice = true);
    this.formSelect.store = JSON.parse(localStorage.getItem("shop")).name;
    this.formSelect.salesperson = JSON.parse(
      localStorage.getItem("adminUser")
    ).name;
    this.formSelect.salespersonid = JSON.parse(
      localStorage.getItem("adminUser")
    ).id;
    this.getGoodsList(this.cid, this.sid);
    this.getCustomerList();
    this.getBankList();
    //成本权限
    var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code;
    if(!PermisCode.includes('94')){    
      this.cpriceFlag = false;
    }
  },

  watch: {
    /*搜索商品*/
    searchNeirong: {
      deep: true,
      handler: function(newVal, oldVal) {
        this.searchNeirong = newVal.replace(">", ":");
        this.searchNeirong = newVal.replace("》", ":");
        this.$set(this.page, "page", 1);
        this.$set(this.page, "current", 1);
        this.getGoodsList(this.cid, this.sid);
      }
    },
    searchnumber: {
      deep: true,
      handler: function(newVal, oldVal) {
        this.searchnumber = newVal.replace(">", ":");
        this.searchnumber = newVal.replace("》", ":");
        this.$Api
          .getGoodsByBarcode({
            barCode: this.searchnumber,
            sid: localStorage.sid
          })
          .then(res => {
            if (res.code == 200) {
              this.resultItem.single = res.data.id;
              this.resultItem.goodsimg = res.data.goodsimg;
              this.resultItem.name = res.data.name;
              this.resultItem.price = res.data.cprice;
              this.resultItem.num = res.data.num;
              this.resultItem.colors = res.data.colors;
              this.resultItem.sizes = res.data.sizes;
              this.resultItem.goodsItem = res.data.goodsItem;
            }
          });
      }
    },
    "formSelect.realMoney": {
      deep: true,
      handler: function(newVal, oldVal) {
        this.formSelect.nomoneys =
          this.formSelect.showMoneys - this.formSelect.realMoney;
        this.Lastmoney = newVal;
      }
    },
    "formSelect.user": {
      deep: true,
      handler: function(newVal, oldVal) {
        this.customerList.forEach((item, index) => {
          if (item.id == newVal) {
            this.formSelect.customerArrears = item.money;
            this.formSelect.user = item.id;
            this.formSelect.username = item.name;
          }
        });
      }
    },
    "formSelect.bank": {
      deep: true,
      handler: function(newVal, oldVal) {
        this.bankList.forEach((item, index) => {
          if (item.id == newVal) {
            this.formSelect.bankName = item.bankname;
          }
        });
      }
    },

    //扫码商品啊
    scanGoods: {
      deep: true,
      handler: function(val) {
        if (this.currentPageData == "") {
          this.currentPageData.push(val);
        } else {
          var flags = true;
          for (var i = 0; i < this.currentPageData.length; i++) {
            if (this.currentPageData[i].id == val.id) {
              this.currentPageData[i].goodsItem.forEach(item => {
                item.nums++;
              });
              flags = false;
              break;
            }
          }
          if (flags) {
            this.currentPageData.push(val);
          }
        }
        sessionStorage.setItem("gools", JSON.stringify(this.currentPageData));
        this.addsSelectItem("true");
      }
    },
    // 计算总数
    changenumber: {
      deep: true,
      handler: function(val) {
        if (this.allobj.length == 0) {
          this.allobj.push({ id: this.changeid, num: this.changenumber });
        } else {
          let state = true;
          this.allobj.forEach(item => {
            if (item.id == this.changeid) {
              item.num = this.changenumber;
              state = false;
              return;
            }
          });
          if (state) {
            this.allobj.push({ id: this.changeid, num: this.changenumber });
          }
        }
        this.allnumber = 0;
        this.allobj.forEach(item => {
          this.allnumber += item.num;
        });
      }
    }
  },
  computed: {
    scanGoods() {
      return this.$store.state.scanGoods;
    }
  },
  beforeDestroy() {
    this.$store.commit("clearScanGoods");
  },
  methods: {
    //修改价格   item每条数据 i-goodsItem第几个 price价格 flag客户类别 type类别 1代表修改价格 2修改百分比 3修改数量
    editprice(item, i, price, type) {
      if (!price) {
        price = 0;
      }
      this.getEdtiVal = price;
      this.afterSelection.forEach(alt => {
        if (alt.goodsid == item.goodsid) {
          if (type == 1) {
            //修改单价
            alt.goodsItem[i].cprice = this.getEdtiVal;
          } else {
            //修改数量
            if (
              (type == 2 && this.getEdtiVal == 0) ||
              (type == 2 && !this.getEdtiVal)
            ) {
              this.getEdtiVal = 1;
            }
            alt.goodsItem[i].nums = this.getEdtiVal;
          }
        }
      });
      this.formSelect.showMoneys = 0;
      this.formSelect.total = 0;
      this.afterSelection.forEach((item, index) => {
        item.goodsItem.forEach((m, n) => {
          let num = m.nums * m.cprice;
          num = parseFloat(num.toFixed(2));
          this.formSelect.showMoneys = parseFloat(
            (this.formSelect.showMoneys + num).toFixed(2)
          );
          this.formSelect.total += m.nums;
        });
      });
      this.Lastmoney = this.formSelect.showMoneys;
      this.formSelect.realMoney = this.formSelect.showMoneys;
      this.formSelect.nomoneys =
        this.formSelect.showMoneys - this.formSelect.realMoney;
    },

    /** 修改总的单价 **/
    editallprice(item, flag, type) {
      this.getEdtiVal = 0;
      this.$Modal.warning({
        render: h => {
          return h("InputNumber", {
            props: {
              value: null,
              autofocus: true,
              min: 0,
              max: 999999
            },
            on: {
              input: val => {
                this.getEdtiVal = val;
              }
            }
          });
        },
        onOk: () => {
          if (this.getEdtiVal != "") {
            this.afterSelection.forEach(alt => {
              if (alt.goodsid == item.goodsid) {
                alt.goodsItem.forEach(w => {
                  w.cprice = this.getEdtiVal;
                });
              }
            });
            this.formSelect.showMoneys = 0;
            this.formSelect.total = 0;
            this.afterSelection.forEach((item, index) => {
              item.goodsItem.forEach((m, n) => {
                let num = m.nums * m.cprice;
                num = parseFloat(num.toFixed(2));
                this.formSelect.showMoneys = parseFloat(
                  (this.formSelect.showMoneys + num).toFixed(2)
                );
                this.formSelect.total += m.nums;
              });
            });
            this.Lastmoney = this.formSelect.showMoneys;
            this.formSelect.realMoney = this.formSelect.showMoneys;
            this.formSelect.nomoneys =
              this.formSelect.showMoneys - this.formSelect.realMoney;
          }
        }
      });
    },
    getCustomerList() {
      //获取供应商列表
      this.$Api
        .getSupplierList({
          cid: this.cid,
          sid: this.sid,
          page: 1,
          rows: 1000
        })
        .then(res => {
          if (res.code == 200) {
            this.customerList = res.data;
            this.customerList = res.data.filter(item => item.isdel == 1);
            this.formSelect.user = this.customerList[0].id;
            this.formSelect.username = this.customerList[0].name;
            this.formSelect.customerArrears = this.customerList[0].money;
          } else {
            this.$Message.warning(res.msg);
          }
        });
    },
    //加载缓存中的再次开单
    getSessionData() {
      var tabledata = JSON.parse(sessionStorage.getItem("openaddpurc"));
      sessionStorage.setItem("gools", JSON.stringify(tabledata.pgoods));//缓存已选商品

      this.afterSelection = tabledata.pgoods;
      this.afterSelection.forEach(item => {
        item.goodsItem.forEach(m => {
          this.formSelect.total += m.quantity;
        });
      });

      this.formSelect.user = tabledata.supplierid;
      this.formSelect.salesperson = tabledata.adminid;

      //商品金额
      this.formSelect.showMoneys = tabledata.money;
      this.formSelect.realMoney = tabledata.money;
      this.Lastmoney = tabledata.money;
    },

    //获取所有商品列表
    getGoodsList() {
      this.$Api
        .getListByGoodsnameOrGoodscode({
          cid: this.cid,
          sid: this.sid,
          page: this.page.page,
          rows: this.page.rows,
          condition: this.searchNeirong //查询内容
        })
        .then(res => {
          if (res.code == 200) {
            this.page.total = res.count;
            this.goodsListL = res.data;

            /**再次开单回填**/
            if (this.$route.query.type != undefined  && this.againSale) {
              this.getSessionData(); //再次开单
            }
            this.setDataListFn(this.goodsListL, 0);
          } else {
            this.$Message.warning(res.msg);
          }
        });
    },
    setDataListFn(getData, i) {
      this.resultItem.single = getData[i].id;
      this.resultItem.goodsimg = getData[i].goodsimg;
      this.resultItem.name = getData[i].name;
      this.resultItem.cprice = getData[i].cprice;
      this.resultItem.num = getData[i].num;
      this.resultItem.colors = getData[i].colors;
      this.resultItem.sizes = getData[i].sizes;
      this.resultItem.goodsItem = getData[i].goodsItem;

      this.selectColorGroup.index = i;
      /*** 回填缓存中的数据 **/
      var sessgools = JSON.parse(sessionStorage.getItem("gools"));

      if (sessgools != null) {
        sessgools.forEach((item, index) => {
          this.goodsListL.forEach((m, n) => {
            if (item.id == m.id) {
                //再次开始单时缺的数据，统一使用商品列表的。
                let name = this.goodsListL[n].name;
                let lprice = this.goodsListL[n].lprice;
                let pprice = this.goodsListL[n].pprice;
                let cprice = this.goodsListL[n].cprice;
                let colors = getData[n].colors;//颜色组
                let sizes = getData[n].sizes;//规格组
                let num = getData[n].num;//库存

                this.goodsListL[n] = sessgools[index];
                this.goodsListL[n].name = name;
                this.goodsListL[n].lprice = lprice;
                this.goodsListL[n].pprice = pprice;
                this.goodsListL[n].cprice = cprice;
                this.goodsListL[n].colors = colors;
                this.goodsListL[n].sizes = sizes;
                this.goodsListL[n].num = num;
            }
          });
        });
      }

      this.setMoneyall();
      this.setColorsFn(getData, i, 0);
    },
    //选择的颜色
    setColorsFn(getData, i, n) {
      this.selectData.all = 0;
      this.resultNum = 0;
      this.selectColorGroup.isCheckable = n;
      var resultColor = getData[i].colors[n].color;

      var resultGoodsItem = getData[i].goodsItem;

      this.resultItem.goodsItem = [];

      resultGoodsItem.forEach((k, v) => {
        if (k.color == resultColor) {
          this.resultItem.goodsItem.push(k);
        }
      });

      this.numsreadonly = false;
      this.resultItem.goodsItem.forEach(w => {
        if (w.num < 0) {
          this.numsreadonly = true;
        }
      });
    },
    //修改总数量
    selectDataAll(n) {
      if (n == this.resultNum + 1) {
        this.resultItem.goodsItem.forEach((item, index) => {
          this.resultItem.goodsItem[index].nums++;
        });
      } else if (n + 1 == this.resultNum) {
        this.resultItem.goodsItem.forEach((item, index) => {
          if (this.resultItem.goodsItem[index].nums <= 0) {
            this.resultItem.goodsItem[index].nums = 0;
          } else {
            this.resultItem.goodsItem[index].nums--;
          }
        });
      } else {
        this.resultItem.goodsItem.forEach((item, index) => {
          if (
            n > this.resultItem.goodsItem[index].nums ||
            n < this.resultItem.goodsItem[index].nums
          ) {
            this.resultItem.goodsItem[index].nums = n;
          }
        });
      }
      this.resultNum = n;
      this.setMoneyall();
    },
    changeNums(data) {
      if (data.num < 0 && this.isShowcprice) {
        this.$Modal.confirm({
          title: "提示",
          content: "<p>当前库存小于0，请先盘点再进行采购</p>",
          okText: "盘点",
          onOk: () => {
            this.$router.push("/addInvhist");
          }
        });
        return;
      }
      this.setMoneyall();
    },
    allchangeNums(str) {
      if (str) {
        this.$Modal.confirm({
          title: "提示",
          content: "<p>当前库存小于0，请先盘点再进行采购</p>",
          okText: "盘点",
          onOk: () => {
            this.$router.push("/addInvhist");
          }
        });
        return;
      }
    },

    setMoneyall() {
      /** 计算当前向的总件数和总金额 **/
      var allPieces = 0;
      var checks = 0;
      this.goodsListL[this.selectColorGroup.index].goodsItem.forEach(
        (value, index) => {
          checks = checks + value.nums;
          allPieces =
            allPieces +
            this.goodsListL[this.selectColorGroup.index].goodsItem[index].nums;
        }
      );
      //计算酸选的总数
      this.goodsListL[this.selectColorGroup.index].nums = checks;
      if (checks == 0) {
        var sessgools = JSON.parse(sessionStorage.getItem("gools"));
        var goodID = this.goodsListL[this.selectColorGroup.index];
        if (sessgools != null) {
          sessgools.forEach((item, index) => {
            if (item.id == goodID.id) {
              sessgools.splice(index, 1);
            }
          });
          this.currentPageData.forEach((item, index) => {
            if (item.id == goodID.id) {
              this.currentPageData.splice(index, 1);
            }
          });
          sessionStorage.setItem("gools", JSON.stringify(sessgools));
        }
      }
      //总件数
      this.summary.totalPieces = allPieces;
      this.changeid = this.goodsListL[this.selectColorGroup.index].id;
      this.changenumber = allPieces;
      //总金额
      this.summary.totalMoney = allPieces * this.resultItem.price;
      //再次开单时初始数据
      if (this.$route.query.type != undefined && this.againSale) {
        this.againSale = false;
        var tabledata = JSON.parse(sessionStorage.getItem("openaddpurc"));
        tabledata.pgoods.forEach((item)=>{
          allPieces += item.nums;
          this.changeid = item.id;
          this.changenumber = allPieces;//总件数 
          this.currentPageData.push(item);     
        });
      }      
      this.selectDataSingle();
    },

    //设置缓存所选择的项
    selectDataSingle() {
      /** 储存当前页的所选数据 **/
      var listArray = null;
      for (
        var i = 0;
        i < this.goodsListL[this.selectColorGroup.index].goodsItem.length;
        i++
      ) {
        if (
          this.goodsListL[this.selectColorGroup.index].goodsItem[i].nums != 0
        ) {
          listArray = this.goodsListL[this.selectColorGroup.index];
          break;
        }
      }
      if (listArray != null) {
        if (this.currentPageData == "") {
          this.currentPageData.push(listArray);
        } else {
          var flags = true;
          for (var i = 0; i < this.currentPageData.length; i++) {
            if (this.currentPageData[i].id == listArray.id) {
              this.currentPageData[i] = listArray;
              flags = false;
              break;
            }
          }
          if (flags) {
            this.currentPageData.push(listArray);
          }
        }
        sessionStorage.setItem("gools", JSON.stringify(this.currentPageData));
      }
    },
    //添加按钮
    async addsSelectItem(str) {
      var getGools = JSON.parse(sessionStorage.getItem("gools"));
      this.afterSelection = [];
      var listArray1 = [];
      //采购平均价取上次采购价格
      let goodsIds = [];
      //打开了采购平均价
      if (this.statenum == 1 && null != getGools && getGools.length > 0 ) {
        this.historyPrice = true;
        getGools.forEach(item => {
          goodsIds.push(item.id);
        });
        // 获取历史价格
        if (goodsIds.length > 0  && this.historyPrice) {
          await this.$Api.getCpriceHistory({
              sid: this.sid,
              cusId: this.formSelect.user,
              goodsIds: goodsIds.join(",")
          }).then(res => {
              let list = res.data;
              //循环商品，替换历史价格
              getGools.forEach(item => {
                //循环单品
                for (let v = 0; v < item.goodsItem.length; v++) {
                  let flag = false;
                  //历史价格组
                  if (list.length > 0) {
                    //循环历史价格组
                    for (let n = 0; n < list.length; n++) {
                      //商品ID+颜色+规格
                      let itemSupId =item.goodsItem[v].goodsid +"" +item.goodsItem[v].colorid +"" +item.goodsItem[v].sizeid;
                      let listSupId =list[n].goodsid +"" +list[n].colorid +"" +list[n].sizeid;
                      if (itemSupId == listSupId) {
                        //用历史采购价的第一个单品价格替换所有的单品价格
                        item.goodsItem.forEach((k, l) => {
                          k.cprice = list[n].cprice;
                        });
                        flag = true;
                        break;
                      }
                    }
                    //结束本次商品，处理下一个商品
                    if (flag) {
                      break;
                    }
                  }
                }
              });
            })
            .catch(err => {
              console.log("获取采购历史价格失败");
            });
        }
      }
    
      if(null != getGools && getGools.length>0){
      getGools.forEach((item, index) => {
        if (JSON.stringify(item) != "{}") {
          var itemArray = [];
          item.goodsItem.forEach((m, v) => {
            //有历史价格的用历史价格
            let cprice = item.cprice;
            if (m.cprice != null && this.statenum == 1 && getGools.length > 0 && this.historyPrice) {
                cprice = m.cprice;
            }

            if (m.nums != 0) {
              itemArray.push({
                color: m.color,
                colorid: m.colorid,
                cprice: cprice,
                goodsid: m.goodsid,
                id: m.id,
                quantity: m.nums,
                size: m.size,
                sizeid: m.sizeid,
                nums: m.nums,
                sid: m.sid,
                num: m.num
              });
            }
          });
          if (itemArray != "") {
            listArray1.push({
              goodsItem: itemArray,
              goodscode: item.goodscode,
              goodsid: item.id,
              goodsimg: item.goodsimg,
              goodsname: item.name,
              lprice: item.lprice,
              cprice: item.cprice
            });
            itemArray = [];
          }
        }
      });

      if (this.afterSelection == "") {
        this.afterSelection = listArray1;
      } else {
        listArray1.forEach((item, index) => {
          if (this.afterSelection.indexOf(item) == -1) {
            this.afterSelection.splice(index, 1, item);
          } else {
            this.afterSelection.push(item);
          }
        });
      }
      }
      if (str == "true") {
        this.commodityModal = false;
      }
      this.formSelect.showMoneys = 0;
      this.formSelect.total = 0;
      this.afterSelection.forEach((item, index) => {
        item.goodsItem.forEach((m, n) => {
          this.formSelect.showMoneys += m.nums * m.cprice;
          this.formSelect.total += m.nums;
        });
      });
      this.Lastmoney = this.formSelect.showMoneys;
      this.formSelect.realMoney = this.formSelect.showMoneys;
      this.formSelect.nomoneys = this.formSelect.showMoneys - this.formSelect.realMoney;
      this.historyPrice = false;//历史价格开关
    },
    //重新编辑
    editSendData(data) {
      this.commodityModal = true;

      // let i=0
      // this.goodsListL.forEach((item,index)=>{
      //     if(data.id==item.id){
      //         i = index
      //     }
      // })
      // this.setDataListFn(this.goodsListL,i)
    },

    //删除
    delSendData(k, index) {
      k.id = k.goodsid;
      var sessgools = JSON.parse(sessionStorage.getItem("gools"));

      if (sessgools != null) {
        sessgools.forEach((item, nu) => {
          if (k.id == item.id) {
            sessgools.splice(nu, 1);
          }
        });
        sessionStorage.setItem("gools", JSON.stringify(sessgools));
      }

      this.afterSelection.splice(index, 1);
      this.currentPageData = this.afterSelection;
      this.goodsListL.forEach((item, index) => {
        if (k.id == item.id) {
          item.nums = 0;
          item.goodsItem.forEach((m, n) => {
            m.nums = 0;
          });
        }
      });

      this.formSelect.showMoneys = 0;
      this.formSelect.total = 0;
      this.afterSelection.forEach((item, index) => {
        item.goodsItem.forEach((m, n) => {
          this.formSelect.showMoneys += m.nums * m.cprice;
          this.formSelect.total += m.nums;
        });
      });
      this.formSelect.realMoney = this.Lastmoney = this.formSelect.showMoneys;
    },

    //修改分页
    onChange(e) {
      this.page.page = e;
      this.getGoodsList(); //加载分页数据
      //this.addsSelectItem()
    },
    //获取银行卡
    getBankList() {
      this.$Api
        .getBankList({
          cid: this.cid,
          sid: this.sid,
          page: 1,
          rows: 1000
        })
        .then(res => {
          if (res.code == 200) {
            this.bankList = res.data;
            this.formSelect.bank = res.data[0].id;
          } else {
            this.$Message.warning(res.msg);
          }
        });
    },

    //出售开单
    openingOrder() {
      this.formSelect.total = 0;
      if (this.afterSelection.length == 0) {
        this.$Message.warning("请添加商品");
        return false;
      }
      //变数字类型
      this.formSelect.realMoney = this.formSelect.realMoney * 1;
      this.afterSelection.forEach(item => {
        item.goodsItem.forEach(m => {
          m.quantity = m.nums;
          this.formSelect.total += m.nums;
        });
      });
      var data = {
        adminid: this.formSelect.salespersonid,
        bank: this.formSelect.bankName,
        bankid: this.formSelect.bank,
        cid: this.cid,
        sid: this.sid,
        pgoods: this.afterSelection,
        supplierid: this.formSelect.user,
        suppliername: this.formSelect.username,
        money: this.formSelect.showMoneys, //总金额
        nomoney: this.formSelect.nomoneys,
        paymoney: this.formSelect.realMoney * 1,
        remark: this.formSelect.remark,
        status: "2",
        total: this.formSelect.total
      };
      this.loadingOpeningOrder = true;
      this.$Api
        .addPurchase(data)
        .then(res => {
          if (res.code == 200) {
            this.$Message.success("开单成功");
            this.$router.push({
              path: "/historyDetail",
              query: {
                id: res.data.purchaseId
              }
            });
          } else {
            this.$Message.warning(res.msg);
          }
          sessionStorage.removeItem("gools");
          this.loadingOpeningOrder = false;
        })
        .catch(err => {
          this.$Message.warning(err.msg);
          this.loadingOpeningOrder = false;
        });
    },
    checkNumber(value) {
      value = value
        .replace(/[^\d^\.]+/g, "")
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", "."); //仅保留数字和"."
      // value = value.replace(/[^\d.]/g, "");  //仅保留数字和"."
      value = value.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      value = value
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      value = value.replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      //首位是0的话去掉
      if (value.indexOf(".") < 0 && value != "") {
        value = parseFloat(value);
      } else if (value == null || value == "" || value.indexOf(".") == 0) {
        value = 0;
      } else if (document.activeElement.name == "realMoneyName") {
        this.formSelect.realMoney = value;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.form-title {
  line-height: 54px;
  border-bottom: 1px solid #d9d9d9;
  margin-bottom: 20px;
}
.ive-table {
  width: 100%;
  border-collapse: collapse;
  th {
    background: #bfdeff;
    padding: 10px;
  }
  tr td {
    border: 1px solid #ececec;
    padding: 5px;
  }
}
.demo-split {
  height: 600px;
  border: 1px solid #dcdee2;
}
.pageTotal {
  display: flex;
  justify-content: space-between;
}
.zongshu {
  position: relative;
  top: 5px;
  color: rgba(255, 148, 94, 1);
  font-size: 18px;
}
.demo-split-pane {
  padding: 20px;
  position: relative;
  height: 598px;
}
.commodityMsg {
  position: relative;
  padding-left: 105px;
  margin-top: 10px;
  height: 110px;
  .img {
    position: absolute;
    left: 15px;
    top: 0;
  }
  h3 {
    padding-top: 5px;
  }
  .money {
    color: rgba(255, 148, 94, 1);
  }
  .num {
    color: rgba(84, 169, 119, 1);
  }
}
.commodityClolr {
  padding: 20px 0;
  h3 {
    padding: 5px 0 5px 0;
  }
  .tag {
    display: inline-block;
    padding: 4px 8px;
    border: 1px solid #e8eaec;
    color: #515a6e;
    border-radius: 3px;

    cursor: pointer;
    margin: 5px 5px 0 0;
  }
}
.commoditymiss {
  h3 {
    margin: 20px 0 10px;
  }
  table {
    width: 100%;
    text-align: center;
    tr {
      td {
        padding-top: 10px;
      }
    }
  }
}
.Total {
  width: 100%;
  position: absolute;
  right: 0;
  bottom: 0;
  text-align: center;
  padding: 15px;
  background: #dcdee2;
  color: #ff9900;
}
.formSelect-input {
  width: 180px;
}

.isSelectClass {
  background: #ff9800;
  color: #ffffff !important;
}
.msg {
  display: inline-block;
  margin-bottom: 20px;
  strong {
    color: #ff7f7f;
  }
}
</style>